module.exports = __webpack_public_path__ + "img/PD1505104523557994496.116edaa7.png";